import {AfterViewInit, Component, ElementRef, forwardRef, HostListener, Input, OnDestroy, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

declare const $: any;
declare const toastr: any;

@Component({
    selector: 'signature-field',
    template: `<div class="signature">
        <a class="mtv-primary-color" (click)="ClearSign()" *ngIf="value">Clear</a>
        <a class="mtv-primary-color" (click)="StartSign()" *ngIf="!value">Sign</a>
        <canvas #canvas></canvas>
    </div>`,
    styleUrls: ['./signature-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SignatureFieldComponent),
            multi: true
        }
    ],
})
export class SignatureFieldComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {

    @Input() showSignModal = false;
    @ViewChild('canvas') canvas: ElementRef;
    private cnvElement: HTMLCanvasElement;
    private ctxElement: CanvasRenderingContext2D;
    private width: number = null;
    private height: number = null;

    private fakeElement;
    private fakeEvent;

    //The internal data model
    private innerValue: string = '';

    //get accessor
    get value(): string {
        return this.innerValue;
    }

    //set accessor including call the onchange callback
    set value(v: string) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
            this.drawSign(v);
        }
    }

    writeValue(value: string) {
        if (value !== this.innerValue) {
            this.innerValue = value;
            this.drawSign(value);
        }
    }

    onTouchedCallback: () => void = () => {};
    onChangeCallback: (_: any) => void = () => {};

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    ngAfterViewInit(): void {
        this.cnvElement = this.canvas.nativeElement;
        this.ctxElement = this.cnvElement.getContext('2d');
        this.width = this.cnvElement.width;
        this.height = this.cnvElement.height;

        const message = {
            firstName: '',
            lastName: '',
            eMail: '',
            location: '',
            imageFormat: 1,
            imageX: this.width,
            imageY: this.height,
            imageTransparency: false,
            imageScaling: false,
            maxUpScalePercent: 0.0,
            rawDataFormat: 'ENC',
            minSigPoints: 25
        };

        const messageData = JSON.stringify(message);

        this.fakeElement = document.createElement('MyExtensionDataElement');
        this.fakeElement.setAttribute('messageAttribute', messageData);
        document.documentElement.appendChild(this.fakeElement);

        this.fakeEvent = document.createEvent('Events');
        this.fakeEvent.initEvent('SignStartEvent', true, false);

        if (this.showSignModal) {
            this.StartSign();
        }
    }

    ClearSign(): void {
        this.value = '';
        this.ctxElement.clearRect(0, 0, this.width, this.height);
    }

    StartSign(): void {
        this.ctxElement.clearRect(0, 0, this.width, this.height);
        this.fakeElement.dispatchEvent(this.fakeEvent);
    }

    setValues(obj): void {
        if (obj.errorMsg != null && obj.errorMsg != '' && obj.errorMsg != 'undefined') {
            toastr.warning(obj.errorMsg);
        } else {
            if (obj.isSigned) {
                this.value = obj.imageData;
            }
        }
    }

    drawSign(imageData): void {
        if (!imageData) return;
        const imageWidth = this.width;
        const imageHeight = this.height;
        const ctx = this.ctxElement;
        const img = new Image();
        img.onload = function () {
            ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
        };
        img.src = 'data:image/png;base64,' + imageData;
    }

    @HostListener('document:SignResponse', ['$event']) SignResponse(event) {
        const str = event.target.getAttribute('msgAttribute');
        const obj = JSON.parse(str);
        this.setValues(obj);
    }

    ngOnDestroy(): void {
        $('MyExtensionDataElement').remove();
        $('MyExtDataElem').remove();
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/signature-field/signature-field.component.ts